export enum UserPageView {
  ListUsers,
  OrderFilePermissions,
}
